export default __webpack_public_path__ + "static/media/Catalyst_LE.bf63dc0d.jpg";